import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticketmaster',
  templateUrl: './ticketmaster.component.html',
  styleUrls: ['./ticketmaster.component.scss']
})
export class TicketmasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
